<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
    persistent
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
                primary--text
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
          >{{ translations.request_guide_dialog_title }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon
                color="primary"
                style="font-size: 150px; width: 200px; height: 150px;"
              >
                mdi-truck
              </v-icon>
            </v-col>
            <v-col class="text-center">
              <span class="font-weight-bold text-body-1">
                {{ translations.request_guide_dialog_content }}
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col class="text-end">
              <v-btn
                color="primary"
                @click="closeModal"
                block
                class="
                mb-5
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
              >
                {{ translations.accept }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({}),

  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
